module.exports = __webpack_public_path__ + "static/media/4.Applause 1.0a387181.gif";